import { useEffect } from "react";

const DEFAULTS = {
  title: "Upload Counsel — Lawyer for YouTubers, Streamers, Creators & Online Businesses",
  description: "Upload Counsel is a creator-economy lawyer concierge for YouTubers, TikTokers, streamers, podcasters, and digital creators. Platform disputes, brand deals, trademarks, business setup, reputation.",
};

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  if (!url) return;
  let el = document.querySelector("link[rel='canonical']");
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

/**
 * useSEO({ title, description, canonical, image })
 * Sets document.title + meta description + og + twitter + canonical for the current page.
 */
export default function useSEO({ title, description, canonical, image } = {}) {
  useEffect(() => {
    const finalTitle = title || DEFAULTS.title;
    const finalDesc = description || DEFAULTS.description;
    const finalImg = image || "https://uploadlawyer.com/og-image.jpg";
    const finalUrl = canonical || (typeof window !== "undefined" ? `https://uploadlawyer.com${window.location.pathname}` : "");

    document.title = finalTitle;
    setMeta("description", finalDesc);
    setMeta("og:title", finalTitle, "property");
    setMeta("og:description", finalDesc, "property");
    setMeta("og:url", finalUrl, "property");
    setMeta("og:image", finalImg, "property");
    setMeta("twitter:title", finalTitle);
    setMeta("twitter:description", finalDesc);
    setMeta("twitter:image", finalImg);
    setCanonical(finalUrl);

    return () => {
      document.title = DEFAULTS.title;
      setMeta("description", DEFAULTS.description);
    };
  }, [title, description, canonical, image]);
}
